import React, { Fragment } from 'react';
import ModuleComponent from '../module';
import * as env from './../../environment';
import { number_format, get_box_color } from './../utils/utils'
import { FormRow, ButtonRefresh } from "./../../generalStyles/mixin";
import transitions from '@material-ui/core/styles/transitions';

const { API_URL_MOTOR } = env[process.env.NODE_ENV];
const { API_USER } = env[process.env.NODE_ENV];
const { API_PASS } = env[process.env.NODE_ENV];

export class stateProcess extends React.Component {

  state = { summaryBoxes: [], authToken: String, hovered: false }

  _getToken() {

    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        password: API_PASS,
        username: API_USER
      })
    };

    fetch(`${API_URL_MOTOR}/api/authenticate`, requestOptions)
      .then(result => result.json())
      .then(autenticationToken => {
        this.setState({ authToken: autenticationToken.token });
        this._fetchBoxes();
      });
  }

  _fetchBoxes() {

    const requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    };
    fetch(`${API_URL_MOTOR}/api/instance/summary`)
      .then(result => result.json())
      .then(response => {
        console.log({ response })

        console.log(this._getTotalIndex(response.summaryBoxes))
        var totalElement = response.summaryBoxes.splice(this._getTotalIndex(response.summaryBoxes), 1);
        response.summaryBoxes.push(totalElement[0]);

        this.setState({ summaryBoxes: response.summaryBoxes, authToken: '' })
      });
  }

  _getTotalIndex(summaryArray) {
    let indice = 0;
    summaryArray.map((orderBox, index) => {
      const { title } = orderBox;
      if (title === 'Total') {
        indice = index
      }
    })

    return indice;
  }

  componentDidMount() {
    //this._getToken()
    this._fetchBoxes();

  }

  handleRefresh() {
    this.setState({ summaryBoxes: [], hovered: false });
    this._fetchBoxes();
  }

  render() {
    if (this.state.summaryBoxes.length > 0) {
      return (
        <Fragment>
          <FormRow style={{marginTop: "-70px", padding: "10px 10px 0px 0px"}}>
            <ButtonRefresh 
              src="/images/refresh.png" 
              style={{transform: `${this.state.hovered ? 'rotate(280deg)' : 'rotate(80deg)'}`}}
              onMouseOver={() => this.setState({hovered: true})} 
              onMouseOut={() => this.setState({hovered: false})} 
              onClick={this.handleRefresh.bind(this)} />
          </FormRow>

          {this.state.summaryBoxes.map(box => {
            const { title, quantity, amount } = box;
            return (

              <ModuleComponent
                title={title}
                number={quantity}
                textNumber=''
                textAmount=''
                style={get_box_color(title)}
              />

            )
          })}
        </Fragment>
      )
    } else {
      return <p className="text-center">Cargando...</p>
    }
  }

}

export default stateProcess;
